// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3NdB6","right":"styles_right__29zIM"};